import { render, staticRenderFns } from "./EnrollmentsFilter.vue?vue&type=template&id=463a79c6"
import script from "./EnrollmentsFilter.vue?vue&type=script&lang=ts"
export * from "./EnrollmentsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports